// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3IBG-","itemTitle":"ClientEmergencyInfo_itemTitle__12LuG","itemText":"ClientEmergencyInfo_itemText__Zvkdk"};